const CUSTOM_OPERATIONS = ['is duplicate'];

export const isConditionRegular = (condition) => !CUSTOM_OPERATIONS.includes(condition.operation);
